import auth from '@/services/auth'
import store from '@/store'
import {NavigationGuard} from 'vue-router'
import User from 'src/models/Users/User';

export let beforeLoginPath = '';
const authGuard: NavigationGuard = async (to, from, next) => {

  if (to.name === 'login') {
    if (auth.isAuthenticated()) {
      next({path: '/'})
    } else {
      next()
    }
  } else if (auth.isAuthenticated()) {
    let user: User = store.state.user.user || await store.dispatch('user/loadUser')

    if (to.meta && to.meta.access) {
      if (user.checkRole(to.meta.access)) {
        next()
      } else {
        next({name: 'accessDenied'})
      }
    } else if (to.name === 'profilePage' && from.path === '/' && !user.getMsgrs().length) {
      next({name: 'messengersPage'})
    } else {
      next()
    }
  } else {
    next({path: '/login'})
    beforeLoginPath = to.path
  }
}
export default authGuard